import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { checkInputErrorOnlyNumbers, checkInputErrorRequired, useInput } from '@chilecompra/react-kit'
import { Input, Typography } from '@chilecompra/react-kit/components'
import { checkMaxDays } from '../../modules/utils/checkers'
import { useImperativeFormRef } from './QuoteStepOne.hooks'
import { Grid, Suffix } from './QuoteStepOne.styles'

/**
 * The DeliveryTime's component.
 */
const DeliveryTime = props => {
  const { formRef, isDownToTiny, maxDays, period } = props
  const { authInfo } = useSelector(state => state.authorizationProvider)
  const {
    error: deliveryTimeError,
    value: deliveryTimeValue,
    onChange: handleDeliveryTimeChange,
    onError: updateDeliveryTimeError
  } = useInput({
    errorCallbacks: [checkInputErrorRequired(), checkInputErrorOnlyNumbers(), checkMaxDays(maxDays)],
    initialValue: period,
    overwriteCallback: () => period
  })

  useEffect(() => {
    if (!period) {
      return
    }

    updateDeliveryTimeError()
  }, [deliveryTimeValue, maxDays, period])

  useImperativeFormRef(formRef, () => ({ deliveryTimeError, deliveryTimeValue }), [
    deliveryTimeError,
    deliveryTimeValue
  ])

  return (
    <Grid container margin="24px 0 24px">
      <Grid container item direction="column" padding="2px 32px 0 0" sm={4} xs={12}>
        <Typography fontWeight="bold" variant="body2">
          Plazo máximo de entrega
        </Typography>
        <Typography fontWeight="regular" color="black1" variant="body2">
          Selecciona el plazo de ejecución o entrega una vez aceptada la orden de compra.
        </Typography>
      </Grid>
      <Grid item padding={isDownToTiny ? '16px 0 0' : '0 16px 0 0'} sm={4} xs={12}>
        <Input
          disabled={authInfo.hasObserverRole}
          error={deliveryTimeError}
          label="Días hábiles"
          suffix={<Suffix>días</Suffix>}
          type="text"
          value={deliveryTimeValue}
          onChange={handleDeliveryTimeChange}
        />
      </Grid>
    </Grid>
  )
}

DeliveryTime.defaultProps = {
  formRef: {
    current: {}
  },
  isDownToTiny: false,
  period: undefined
}

DeliveryTime.propTypes = {
  formRef: PropTypes.shape({
    current: PropTypes.shape(Object)
  }),
  isDownToTiny: PropTypes.bool,
  maxDays: PropTypes.number,
  period: PropTypes.number
}

export default DeliveryTime
